export const imagePickerWithPreviewContainerStyles = {
	display: 'flex',
	flexDirection: 'column',
};

export const getUploadAndReviewInfoContainerStyles = (isInfoCenterAlign: boolean) => ({
	display: 'flex',
	justifyContent: isInfoCenterAlign ? 'center' : 'flex-start',
	marginBottom: '1rem ',
});

export const cardContainerStyles = {
	height: '9rem',
	alignContent: 'center',
	borderStyle: 'dashed',
	borderRadius: '0.5rem',
	borderColor: 'neutrals.primary',
	backgroundColor: 'backgrounds.neutral',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
};

export const imageContainerStyles = {
	display: 'flex',
	justifyContent: 'center',
	alignContent: 'center',
	flex: '1 0 auto',
	width: '100%',
};

export const getImageStyles = (previewUrl: string) => ({
	backgroundImage: `url("${previewUrl}")`,
	backgroundSize: 'contain',
	backgroundPosition: 'center',
	backgroundRepeat: 'no-repeat',
	width: '100%',
});

export const selectImageInputStyles = {
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
};

export const formLabelStyles = {
	color: 'text.interactive',
};

export const linkStyles = {
	'&:hover': { cursor: 'pointer' },
};
